import { OP, STATUS } from "../../constant";

const INITIAL_STATE = {
  // ------ partner initial-------- //
  partnerListStatus: STATUS.DEFAULT,
  partnerListResult: null,
  partnerListErrormessage: "",

  viewPartnerStatus: STATUS.DEFAULT,
  viewPartnerResult: null,
  viewPartnerErrorMessage: "",

  editPartnerStatus: STATUS.DEFAULT,
  editPartnerResult: null,
  editPartnerErrorMessage: "",

  activatePartnerStatus: STATUS.DEFAULT,
  activatePartnerResult: null,
  activatePartnerErrorMessage: "",

  deactivatePartnerStatus: STATUS.DEFAULT,
  deactivatePartnerResult: null,
  deactivatePartnerErrorMessage: "",

  addPartnerStatus: STATUS.DEFAULT,
  addPartnerResult: null,
  addPartnerErrorMessage: "",

  approvePartnerStatus: STATUS.DEFAULT,
  approvePartnerResult: null,
  approvePartnerErrorMessage: "",

  rejectPartnerStatus: STATUS.DEFAULT,
  rejectPartnerResult: null,
  rejectPartnerErrorMessage: "",

  getActivePartnersStatus: STATUS.DEFAULT,
  getActivePartnersResult: null,
  getActivePartnersErrorMessage: "",

  getLoggedInPartnerDetailsStatus: STATUS.DEFAULT,
  getLoggedInPartnerDetailsResult: null,
  getLoggedInPartnerDetailsErrorMessage: "",

  uploadPartnerPhotoStatus: STATUS.DEFAULT,
  uploadPartnerPhotoResult: null,
  uploadPartnerPhotoErrorMessage: "",
};

const partnerReducers = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    // *-------- > partner list reducers
    case OP.PARTNER_LIST_LOADING:
      return {
        ...state,
        partnerListStatus: STATUS.LOADING,
      };
    case OP.PARTNER_LIST_SUCCESS:
      return {
        ...state,
        partnerListStatus: STATUS.SUCCESS,
        partnerListResult: payload,
        partnerListErrorMessage: "",
      };
    case OP.PARTNER_LIST_FAILURE:
      return {
        ...state,
        partnerListStatus: STATUS.ERROR,
        partnerListResult: null,
        partnerListErrorMessage: payload,
      };
    case OP.PARTNER_LIST_RESET:
      return {
        ...state,
        partnerListStatus: STATUS.DEFAULT,
        partnerListResult: null,
        partnerListErrorMessage: "",
      };

    // *-------- > add partner reducers
    case OP.ADD_PARTNER_LOADING:
      return {
        ...state,
        addPartnerStatus: STATUS.LOADING,
      };
    case OP.ADD_PARTNER_SUCCESS:
      return {
        ...state,
        addPartnerStatus: STATUS.SUCCESS,
        addPartnerResult: payload,
        addPartnerErrorMessage: "",
      };
    case OP.ADD_PARTNER_FAILURE:
      return {
        ...state,
        addPartnerStatus: STATUS.ERROR,
        addPartnerResult: null,
        addPartnerErrorMessage: payload,
      };
    case OP.ADD_PARTNER_RESET:
      return {
        ...state,
        addPartnerStatus: STATUS.DEFAULT,
        addPartnerResult: null,
        addPartnerErrorMessage: "",
      };

    // *-------- > view partner reducers
    case OP.VIEW_PARTNER_LOADING:
      return {
        ...state,
        viewPartnerStatus: STATUS.LOADING,
      };
    case OP.VIEW_PARTNER_SUCCESS:
      return {
        ...state,
        viewPartnerStatus: STATUS.SUCCESS,
        viewPartnerResult: payload,
        viewPartnerErrorMessage: "",
      };
    case OP.VIEW_PARTNER_FAILURE:
      return {
        ...state,
        viewPartnerStatus: STATUS.ERROR,
        viewPartnerResult: null,
        viewPartnerErrorMessage: payload,
      };
    case OP.VIEW_PARTNER_RESET:
      return {
        ...state,
        viewPartnerStatus: STATUS.DEFAULT,
        viewPartnerResult: null,
        viewPartnerErrorMessage: "",
      };

    // *-------- > edit partner reducers
    case OP.EDIT_PARTNER_LOADING:
      return {
        ...state,
        editPartnerStatus: STATUS.LOADING,
      };
    case OP.EDIT_PARTNER_SUCCESS:
      return {
        ...state,
        editPartnerStatus: STATUS.SUCCESS,
        editPartnerResult: payload,
        editPartnerErrorMessage: "",
      };
    case OP.EDIT_PARTNER_FAILURE:
      return {
        ...state,
        editPartnerStatus: STATUS.ERROR,
        editPartnerResult: null,
        editPartnerErrorMessage: payload,
      };
    case OP.EDIT_PARTNER_RESET:
      return {
        ...state,
        editPartnerStatus: STATUS.DEFAULT,
        editPartnerResult: null,
        editPartnerErrorMessage: "",
      };

    // *-------- > activate partner reducers
    case OP.ACTIVATE_PARTNER_LOADING:
      return {
        ...state,
        activatePartnerStatus: STATUS.LOADING,
      };
    case OP.ACTIVATE_PARTNER_SUCCESS:
      return {
        ...state,
        activatePartnerStatus: STATUS.SUCCESS,
        activatePartnerResult: payload,
        activatePartnerErrorMessage: "",
      };
    case OP.ACTIVATE_PARTNER_FAILURE:
      return {
        ...state,
        activatePartnerStatus: STATUS.ERROR,
        activatePartnerResult: null,
        activatePartnerErrorMessage: payload,
      };
    case OP.ACTIVATE_PARTNER_RESET:
      return {
        ...state,
        activatePartnerStatus: STATUS.DEFAULT,
        activatePartnerResult: null,
        activatePartnerErrorMessage: "",
      };

    // *-------- > deactivate partner reducers
    case OP.DEACTIVATE_PARTNER_LOADING:
      return {
        ...state,
        deactivatePartnerStatus: STATUS.LOADING,
      };
    case OP.DEACTIVATE_PARTNER_SUCCESS:
      return {
        ...state,
        deactivatePartnerStatus: STATUS.SUCCESS,
        deactivatePartnerResult: payload,
        deactivatePartnerErrorMessage: "",
      };
    case OP.DEACTIVATE_PARTNER_FAILURE:
      return {
        ...state,
        deactivatePartnerStatus: STATUS.ERROR,
        deactivatePartnerResult: null,
        deactivatePartnerErrorMessage: payload,
      };
    case OP.DEACTIVATE_PARTNER_RESET:
      return {
        ...state,
        deactivatePartnerStatus: STATUS.DEFAULT,
        deactivatePartnerResult: null,
        deactivatePartnerErrorMessage: "",
      };

    // *-------- >approve Partner reducers
    case OP.APPROVE_PARTNER_LOADING:
      return {
        ...state,
        approvePartnerStatus: STATUS.LOADING,
      };
    case OP.APPROVE_PARTNER_SUCCESS:
      return {
        ...state,
        approvePartnerStatus: STATUS.SUCCESS,
        approvePartnerResult: payload,
        approvePartnerErrorMessage: "",
      };
    case OP.APPROVE_PARTNER_FAILURE:
      return {
        ...state,
        approvePartnerStatus: STATUS.ERROR,
        approvePartnerResult: null,
        approvePartnerErrorMessage: payload,
      };
    case OP.APPROVE_PARTNER_RESET:
      return {
        ...state,
        approvePartnerStatus: STATUS.DEFAULT,
        approvePartnerResult: null,
        approvePartnerErrorMessage: "",
      };

    // *-------- >reject partner reducers
    case OP.REJECT_PARTNER_LOADING:
      return {
        ...state,
        rejectPartnerStatus: STATUS.LOADING,
      };
    case OP.REJECT_PARTNER_SUCCESS:
      return {
        ...state,
        rejectPartnerStatus: STATUS.SUCCESS,
        rejectPartnerResult: payload,
        rejectPartnerErrorMessage: "",
      };
    case OP.REJECT_PARTNER_FAILURE:
      return {
        ...state,
        rejectPartnerStatus: STATUS.ERROR,
        rejectPartnerResult: null,
        rejectPartnerErrorMessage: payload,
      };
    case OP.REJECT_PARTNER_RESET:
      return {
        ...state,
        rejectPartnerStatus: STATUS.DEFAULT,
        rejectPartnerResult: null,
        rejectPartnerErrorMessage: "",
      };

    // *-------- >get active partners
    case OP.GET_ACTIVE_PARTNERS_LOADING:
      return {
        ...state,
        getActivePartnersStatus: STATUS.LOADING,
      };
    case OP.GET_ACTIVE_PARTNERS_SUCCESS:
      return {
        ...state,
        getActivePartnersStatus: STATUS.SUCCESS,
        getActivePartnersResult: payload,
        getActivePartnersErrorMessage: "",
      };
    case OP.GET_ACTIVE_PARTNERS_FAILURE:
      return {
        ...state,
        getActivePartnersStatus: STATUS.ERROR,
        getActivePartnersResult: null,
        getActivePartnersErrorMessage: payload,
      };
    case OP.GET_ACTIVE_PARTNERS_RESET:
      return {
        ...state,
        getActivePartnersStatus: STATUS.DEFAULT,
        getActivePartnersResult: null,
        getActivePartnersErrorMessage: "",
      };

    // *-------- >get logged in partner details
    case OP.GET_LOGGED_IN_PARTNER_DETAILS_LOADING:
      return {
        ...state,
        getLoggedInPartnerDetailsStatus: STATUS.LOADING,
      };
    case OP.GET_LOGGED_IN_PARTNER_DETAILS_SUCCESS:
      return {
        ...state,
        getLoggedInPartnerDetailsStatus: STATUS.SUCCESS,
        getLoggedInPartnerDetailsResult: payload,
        getLoggedInPartnerDetailsErrorMessage: "",
      };
    case OP.GET_LOGGED_IN_PARTNER_DETAILS_FAILURE:
      return {
        ...state,
        getLoggedInPartnerDetailsStatus: STATUS.ERROR,
        getLoggedInPartnerDetailsResult: null,
        getLoggedInPartnerDetailsErrorMessage: payload,
      };
    case OP.GET_LOGGED_IN_PARTNER_DETAILS_RESET:
      return {
        ...state,
        getLoggedInPartnerDetailsStatus: STATUS.DEFAULT,
        getLoggedInPartnerDetailsResult: null,
        getLoggedInPartnerDetailsErrorMessage: "",
      };

    // *-------- >upload partner photo
    case OP.UPLOAD_PARTNER_PHOTO_LOADING:
      return {
        ...state,
        uploadPartnerPhotoStatus: STATUS.LOADING,
      };
    case OP.UPLOAD_PARTNER_PHOTO_SUCCESS:
      return {
        ...state,
        uploadPartnerPhotoStatus: STATUS.SUCCESS,
        uploadPartnerPhotoResult: payload,
        uploadPartnerPhotoErrorMessage: "",
      };
    case OP.UPLOAD_PARTNER_PHOTO_FAILURE:
      return {
        ...state,
        uploadPartnerPhotoStatus: STATUS.ERROR,
        uploadPartnerPhotoResult: null,
        uploadPartnerPhotoErrorMessage: payload,
      };
    case OP.UPLOAD_PARTNER_PHOTO_RESET:
      return {
        ...state,
        uploadPartnerPhotoStatus: STATUS.DEFAULT,
        uploadPartnerPhotoResult: null,
        uploadPartnerPhotoErrorMessage: "",
      };

    // *-------- >get partner agents
    case OP.GET_PARTNER_AGENTS_LOADING:
      return {
        ...state,
        getPartnerAgentsStatus: STATUS.LOADING,
      };
    case OP.GET_PARTNER_AGENTS_SUCCESS:
      return {
        ...state,
        getPartnerAgentsStatus: STATUS.SUCCESS,
        getPartnerAgentsResult: payload,
        getPartnerAgentsErrorMessage: "",
      };
    case OP.GET_PARTNER_AGENTS_FAILURE:
      return {
        ...state,
        getPartnerAgentsStatus: STATUS.ERROR,
        getPartnerAgentsResult: null,
        getPartnerAgentsErrorMessage: payload,
      };
    case OP.GET_PARTNER_AGENTS_RESET:
      return {
        ...state,
        getPartnerAgentsStatus: STATUS.DEFAULT,
        getPartnerAgentsResult: null,
        getPartnerAgentsErrorMessage: "",
      };

    default:
      return state;
  }
};

export default partnerReducers;
